<template>
    <v-navigation-drawer
      app
      clipped
      right
      v-model="RIGHT_FACILITY_DRAWER_STATE"
      :mini-variant="isMini"
      permanent
      mini-variant-width="50"
      :class="{'drawer-mini': !RIGHT_FACILITY_DRAWER_STATE}"
      class="mt-15 pb-15 mt-md-16 pb-md-16 facility-quicklink-sidebar"
      width="470"
  >
    <div v-show="!isMini">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs}">
          <v-btn class="pa-5" icon @click.stop="TOOGLE_RIGHT_FACILITY_DRAWER_STATE" v-bind="attrs" v-on="on">
            <v-icon color="primary">close</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('buttons:close-sidebar')}}</span>
      </v-tooltip>
    </div>
    <div v-show="isMini" class="text-center">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs}">
          <v-btn class="pa-5" icon @click.stop="TOOGLE_RIGHT_FACILITY_DRAWER_STATE" v-bind="attrs" v-on="on">
            <v-icon color="primary">link</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('buttons:open-sidebar')}}</span>
      </v-tooltip>
    </div>

    <v-divider></v-divider>

    <!-- Facility info link -->
    <div v-show="!isMini">
      <v-btn
          block
          tile
          text
          class="btn-as-expansion"
          @click="pushToInfoTab('technical')"
      >
        <v-icon>elevator</v-icon>
        <span class="orange-dot ml-1"></span>
        <span class="ml-2 btn-expansion-text">{{ $t('book/facility:common.facility-info')}}</span>
        <v-spacer></v-spacer>
        <v-icon>edit</v-icon>
      </v-btn>
    </div>

    <v-divider v-show="!isMini"></v-divider>

    <v-expansion-panels v-show="!isMini" tile accordion>
      <!-- Docu expansion panel -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row align="center">
            <v-col cols="1"><v-icon>description</v-icon></v-col>
            <v-col cols="6">
              <span class="red-dot"></span>
              <span class="ml-2">{{ $t('common:documentation_plural')}} ({{ restDocus.length }})</span>
            </v-col>
            <v-col cols="5" class="text-right">
              <v-btn color="primary" elevation="0" rounded small @click.native.stop="quickLinkEmit('docuQuickLink', 'documentations')">
                <v-icon>add</v-icon>
                {{ $t('buttons:add')}}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-list>
            <v-list-item-group>
              <v-list-item v-for="item in restDocus" :key="item.id" @click="viewDocument(item)">
                <span class="ml-2">{{ item.name }}</span>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Role expansion panel -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row align="center">
            <v-col cols="1"><v-icon>engineering</v-icon></v-col>
            <v-col cols="6">
              <span class="red-dot"></span>
              <span class="ml-2">{{ $t('common:role_plural')}} ({{ restRoles.length }})</span>
            </v-col>
            <v-col cols="5" class="text-right">
              <v-btn color="primary" elevation="0" rounded small @click.native.stop="quickLinkEmit('roleQuickLink', 'roles')">
                <v-icon>add</v-icon>
                {{ $t('buttons:add')}}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-list>
            <v-list-item-group>
              <v-list-item v-for="item in restRoles" :key="item.id" @click="pushToInfoTab('roles')">
                <v-avatar size="40">
                  <v-img
                      src="@/assets/default_profile_pic.png"
                  ></v-img>
                </v-avatar>
                <v-row class="ml-2" align="center">
                  <v-col>
                    <span>{{ item.userName }} - {{ item.roleName }}</span>
                  </v-col>
                  <v-col cols="4" class="text-right">
                    <v-btn color="primary" icon @click="callPhoneNumber(item.userPhone)">
                      <v-icon>phone</v-icon>
                    </v-btn>
                    <v-btn color="primary" icon @click="writeEMail(item.userEmail)">
                      <v-icon>email</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Process expansion panel -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row align="center">
            <v-col cols="1"><v-icon>account_tree</v-icon></v-col>
            <v-col cols="6">
              <span class="red-dot"></span>
              <span class="ml-2">{{ $t('common:process_plural')}} ({{ restProcesses.length }})</span>
            </v-col>
            <v-col cols="5" class="text-right">
              <v-btn color="primary" elevation="0" rounded small @click.native.stop="quickLinkEmit('processQuickLink', 'processes')">
                <v-icon>add</v-icon>
                {{ $t('buttons:add')}}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-list>
            <v-list-item-group>
              <v-list-item v-for="item in restProcesses" :key="item.id" @click="pushToInfoTab('processes')">
                <span class="ml-2">{{ item.processName }}</span>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- contracts panel -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row align="center">
            <v-col cols="1"><v-icon>developer_board</v-icon></v-col>
            <v-col cols="6">
              <span class="red-dot"></span>
              <span class="ml-2">{{ $t('common:contract_plural')}} ({{ restContracts.length }})</span>
            </v-col>
            <v-col cols="5" class="text-right">
              <v-btn color="primary" elevation="0" rounded small @click.native.stop="quickLinkEmit('contractQuickLink', 'contracts')">
                <v-icon>add</v-icon>
                {{ $t('buttons:add')}}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-list>
            <v-list-item-group>
              <v-list-item v-for="item in restContracts" :key="item.id" @click="pushToInfoTab('contracts')">
                <span class="ml-2">{{ item.name }}</span>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <DocumentViewer ref="documentViewer"/>
  </v-navigation-drawer>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  name: 'FacilityQuickLinkSidebar',
  components: {
    DocumentViewer: () => import('@/modules/core/components/DocumentViewer/DocumentViewer')
  },
  data() {
    return {
      restDocus: [],
      restRoles: [],
      restProcesses: [],
      restContracts: []
    }
  },
  computed: {
    ...mapState('book/layout', {
      rightFacilityDrawer: state => state.rightFacilityDrawer
    }),
    RIGHT_FACILITY_DRAWER_STATE: {
      get() {
        return this.rightFacilityDrawer
      },
      set(newValue) {
        if (newValue === this.rightFacilityDrawer) return;
        this.TOOGLE_RIGHT_FACILITY_DRAWER_STATE();
      }
    },
    isMini() {
      // if screen size is md or lower
      if(this.$vuetify.breakpoint.mdAndDown) {
        return this.RIGHT_FACILITY_DRAWER_STATE
      } else {
        return !this.RIGHT_FACILITY_DRAWER_STATE
      }
    }
  },
  methods: {
    /**
     * Route to specific info sub tab
     *
     * @param tabName name of tab to route to, e.g. 'documentations'
     */
    pushToInfoTab(tabName) {
      if (this.$route.path !==`/facilities/edit/${this.$route.params.id}/info/${tabName}`) {
        this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/facilities/edit/${this.$route.params.id}/info/${tabName}`);
      }
    },

    /**
     * Opens dialog to add item on specific sub info (e.g. documentations)
     * and routes to this tab
     *
     * @param categoryEvent unique name for event (e.g. contractQuickLink)
     * @param infoTabLink name of sub info to route to (e.g. 'contracts')
     */
    quickLinkEmit(categoryEvent, infoTabLink) {
      this.$emit(categoryEvent);
      this.pushToInfoTab(infoTabLink);
    },

    viewDocument(item) {
      this.$refs.documentViewer.initViewerById(this.restDocus, item.id, item.facilityId, item.documentType);
    },

    ...mapActions(
        'book/layout', ['TOOGLE_RIGHT_FACILITY_DRAWER_STATE']
    ),

    // open new window to call user by phone number
    callPhoneNumber(phoneNumber) {
      window.open('tel:' + phoneNumber)
    },

    writeEMail(email) {
      window.open('mailto:' + email)
    },
  }
}
</script>
<style lang="scss">
.facility-quicklink-sidebar {
  .btn-as-expansion {
    justify-content: start;
    height: 52px!important;

    .v-icon {
      color: rgba(0, 0, 0, 0.54)!important;
    }

    .btn-expansion-text {
      color: rgba(0, 0, 0, 0.87);
      font-size: 0.9375rem;
      line-height: 1;
      text-transform: capitalize;
      letter-spacing: normal;
    }
  }
}
</style>